import React, { useState } from 'react';
import { CampaignsList } from './CampaignsList';
import { CampaignModal } from '../layout/CampaignModal';
import { useAppData } from '../../contexts/AppDataContext';
import { useNavigate } from 'react-router-dom';

export const CampaignsPage: React.FC = () => {
  const [showNewCampaignModal, setShowNewCampaignModal] = useState(false);
  const { datasets } = useAppData();
  const navigate = useNavigate();

  return (
    <div className="h-full overflow-auto bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-6 sm:pt-8 pb-8 sm:pb-12">
        {/* Page Header */}
        <div className="mb-6">
          <h1 className="text-[18px] sm:text-[20px] font-semibold text-neutral-900" style={{ letterSpacing: '-0.01em' }}>
            Campaigns
          </h1>
          <p className="text-[13px] text-neutral-500 mt-1">
            Create and manage your outreach campaigns
          </p>
        </div>

        {/* Campaigns List */}
        <CampaignsList onNewCampaign={() => setShowNewCampaignModal(true)} />
      </div>

      {/* New Campaign Modal */}
      <CampaignModal
        isOpen={showNewCampaignModal}
        onClose={() => setShowNewCampaignModal(false)}
        datasets={datasets || []}
        onNewCampaign={() => {
          setShowNewCampaignModal(false);
          navigate('/datasets');
        }}
      />
    </div>
  );
};
